import { render, staticRenderFns } from "./UploadImgBox.vue?vue&type=template&id=e5cbe6e0"
import script from "./UploadImgBox.vue?vue&type=script&lang=js"
export * from "./UploadImgBox.vue?vue&type=script&lang=js"
import style0 from "./UploadImgBox.vue?vue&type=style&index=0&id=e5cbe6e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports